export class ResourceOperationEfficiencyRequest{
    resourceOperationEfficiencyId : number;
    
    constructor(resourceOperationEfficiencyId : number)
    {
        this.resourceOperationEfficiencyId = resourceOperationEfficiencyId;
        
    }
}
